export default __webpack_public_path__ + "static/media/andrew-selbst.d885ff9c.jpg";